import React from 'react'
import { Button } from '@/components/ui/button'
import {
  FormBaseFieldBlock,
  FormBaseFieldGroup,
  FormBaseFieldLabel,
  FormBaseRow,
} from 'components/Form/Form.styles'
import { Field, Form, FormikErrors, FormikProps, withFormik } from 'formik'
import { FormSubmitValues } from 'utils/formValidation'

import { CorporateActionDto } from '../../../api/Trading-Accounts/Types/CorporateActionDto'
import { formatLocalDateUTC } from '../../../utils/date'
import { ButtonContainer, Container } from '../Brokerage.styles'

export interface EditCorporateActionFormValues {
  id: string
  isExcluded: boolean
}

const EditSystemCorporateActionFormUI: React.FC<
  FormikProps<EditCorporateActionFormValues> & OuterProps
> = (props) => {
  const { handleSubmit, setSubmitting, isSubmitting, data } = props
  const handleSubmitForm = () => {
    setSubmitting(true)
    handleSubmit()
  }
  return (
    <Container>
      <Form>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Symbol</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='symbol' type='text' disabled value={data.details.symbol} />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Type</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field
                name='corporateActionType'
                type='text'
                disabled
                value={data.corporateActionType.name}
              />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>External Id</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='externalId' type='text' disabled value={data.externalId} />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Date</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='date' type='text' disabled value={formatLocalDateUTC(data.date, true)} />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Deleted</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='isDeleted' type='checkbox' disabled checked={data.isDeleted} />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Processed</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='isProcessed' type='checkbox' disabled checked={data.isProcessed} />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <FormBaseFieldBlock>
          <FormBaseRow>
            <FormBaseFieldLabel>Excluded</FormBaseFieldLabel>
            <FormBaseFieldGroup>
              <Field name='isExcluded' type='checkbox' />
            </FormBaseFieldGroup>
          </FormBaseRow>
        </FormBaseFieldBlock>
        <ButtonContainer>
          <Button disabled={isSubmitting} key='button' type='button' onClick={handleSubmitForm}>
            Submit
          </Button>
        </ButtonContainer>
      </Form>
    </Container>
  )
}

interface OuterProps {
  data: CorporateActionDto
  onSubmit(values: FormSubmitValues<EditCorporateActionFormValues>): Promise<void>
}

function dataToSubmit(
  values: EditCorporateActionFormValues
): FormSubmitValues<EditCorporateActionFormValues> {
  return {
    id: values.id,
    isExcluded: values.isExcluded,
  }
}

export const EditSystemCorporateActionForm = withFormik<OuterProps, EditCorporateActionFormValues>({
  mapPropsToValues: ({ data }) => {
    return {
      id: data.id,
      isExcluded: data.isExcluded,
    }
  },
  handleSubmit: async (values, { props, setSubmitting }) => {
    try {
      await props.onSubmit(dataToSubmit(values))
    } finally {
      setSubmitting(false)
    }
  },
  validate: () => {
    const errors: FormikErrors<EditCorporateActionFormValues> = {}
    return errors
  },
  enableReinitialize: true,
})(EditSystemCorporateActionFormUI)
